/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as e from "react";
import t from "prop-types";
import { IconWrap as n } from "@progress/kendo-react-common";
import { caretAltLeftIcon as i, caretAltRightIcon as a, caretAltDownIcon as c } from "@progress/kendo-svg-icons";
import { getChildrenPosition as s } from "../utils/misc.mjs";
const l = "caret-alt-down", p = "caret-alt-right", d = "caret-alt-left", r = class r extends e.Component {
  /**
   * @hidden
   */
  render() {
    return /* @__PURE__ */ e.createElement(n, { "aria-hidden": !0, ...this.getIcon() });
  }
  getIcon() {
    switch (s(
      this.props.itemId,
      this.props.verticalMenu === !0,
      this.props.dir === "rtl"
    )) {
      case "downward":
        return { name: l, icon: c };
      case "rightward":
        return { name: p, icon: a };
      case "leftward":
        return { name: d, icon: i };
      default:
        return {};
    }
  }
};
r.propTypes = {
  itemId: t.string,
  dir: t.string,
  verticalMenu: t.bool
};
let o = r;
export {
  o as MenuItemArrow,
  l as downArrowName,
  d as leftArrowName,
  p as rightArrowName
};
